import styled from 'styled-components/macro';
import { CustomScroll } from '@yme/atoms/custom-scroll';
import { colorCoreBlack900Base, colorCoreWhite1000 } from '@yme/tokens/colors';
import { elevationTopLvl4 } from '@yme/tokens/elevations';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { HeadingLevel3, UbuntuFontFamily } from '@yme/tokens/typography';
import { Z_INDEX } from '@yme/tokens/zindex';
import { getTextStyles } from '@yme/utils/styles';
export const BannerWrapperStyled = styled(FlexWrapper) `
  h1,
  h2,
  h3,
  h4,
  h5,
  p,
  .nav-container,
  .rw-box {
    color: ${colorCoreBlack900Base};
    ${UbuntuFontFamily};
  }

  ${({ isExpanded }) => isExpanded && `  overflow-y: auto;`};
  ${CustomScroll};

  color: ${colorCoreBlack900Base};
  background-color: ${colorCoreWhite1000};
  box-shadow: ${elevationTopLvl4};
  z-index: ${Z_INDEX.popupLevel3};

  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;

  transition: 0.3s ease-in-out ${({ isExpanded }) => (isExpanded ? 'all' : 'transform')};
  max-height: ${({ maxHeight }) => maxHeight && maxHeight};
  transform: ${({ isVisible }) => (isVisible ? 'translateY(0)' : 'translateY(100%)')};

  ${({ isRightToLeft }) => isRightToLeft && 'direction: rtl'};

  @media (orientation: landscape) {
    max-height: 100vh;
  }
`;
export const ShowMoreWrapper = styled.div `
  ${getTextStyles('Ubuntu', null, 16, 24)}
`;
export const HeadingLevel3Styled = styled(HeadingLevel3) `
  margin-bottom: 8px;
`;
